
import { UsersTable } from "@/components/settings/admin/stats/UsersTable";
import { Profile } from "@/hooks/profile/types";
import { useRemoveUserFromGym } from "@/hooks/admin/useRemoveUserFromGym";
import { PaymentStatus } from "@/hooks/admin/useUserPayments";
import { DebtInfo } from "@/hooks/admin/useMemberDebts";

interface UsersListProps {
  users: Profile[];
  onBanUser: (userId: string, isBanned: boolean) => void;
  onRoleChange: (userId: string, newRole: string) => void;
  isUpdating: boolean;
  currentUser: Profile | null;
  paymentStatusMap?: Map<string, PaymentStatus>;
  actsAsRecepcionista?: boolean;
  isMastergym?: boolean;
  debtsMap?: Map<string, DebtInfo>;
}

export const UsersList = ({ 
  users, 
  onBanUser, 
  onRoleChange, 
  isUpdating, 
  currentUser,
  paymentStatusMap,
  actsAsRecepcionista = false,
  isMastergym = false,
  debtsMap,
}: UsersListProps) => {
  const { mutate: removeUserFromGym } = useRemoveUserFromGym();

  const handleRemoveFromGym = async (userId: string) => {
    const user = users.find(u => u.id === userId);
    if (!user) return;

    const gymId = user.gym_id;

    if (!gymId) {
      console.error("No gym ID found for user:", userId);
      return;
    }

    console.log("Removing user from gym:", { userId, gymId, isPending: user.isPending });
    removeUserFromGym({ 
      userId, 
      gymId, 
      isPending: user.isPending || false 
    });
  };

  return (
    <UsersTable
      users={users}
      isLoading={isUpdating}
      onBanUser={onBanUser}
      onDeleteUser={handleRemoveFromGym}
      onRoleChange={onRoleChange}
      currentUser={currentUser}
      paymentStatusMap={paymentStatusMap}
      actsAsRecepcionista={actsAsRecepcionista}
      isMastergym={isMastergym}
      debtsMap={debtsMap}
    />
  );
};
